module.exports = __webpack_public_path__ + "static/media/lesson_chapter_6.0b777337.png";